import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AuthenticationService, DialogService } from '../../_services';
import { first } from 'rxjs/operators';
import { CommonService } from '../../_services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonDataService } from '../../appDataServices/commonDataService';

@Component({
  selector: 'add-neft-balance',
  templateUrl: './add-neft-balance.component.html',
})
export class AddNeftBalanceComponent implements OnInit {
  @Input() mode: any = {};
  data: any = {
    accntNo: '',
    ifscCode: '',
    banks: [],
    selectedBank: ''
  };
  loading = false;
  neftFlag;
  ifscLabel = '';
  showBankNameForNEFTDialog = false;
  bankNameForNEFTDialog = '';

  constructor(
    private authenticationService: AuthenticationService,
    private modal: PopoverController,
    private commonService: CommonService,
    public activeModal: NgbActiveModal,
    private commonDataService: CommonDataService
  ) { }

  ngOnInit() {
    this.getVirualACC();
  }

  getVirualACC() {
    this.setAppBusy();
    this.authenticationService.getVirtualAccntDetails().pipe(first()).subscribe(data => {
      this.setAppIdle();
      this.data = data;
      this.data.selectedBank = '';
      if (data.sellerCode) {
        this.getAdditionalDetailsForVirtualAccnt(data.sellerCode);
      }
    }, () => {
      this.setAppIdle();
    });
  }

  setAppBusy() {
    this.loading = true;
  }

  setAppIdle() {
    this.loading = false;
  }

  close() {
    // this.modal.dismiss();
    this.activeModal.dismiss();
  }

  goToBank() {
    console.log("banl");
    console.log(this.data);
    
    if (this.data.selectedBank && this.data.selectedBank.bankUrl) {
      console.log("ban url ");
      console.log(this.data.selectedBank.bankUrl);
      
      this.commonService.openInNewWindow(this.data.selectedBank.bankUrl, false);
    }
  }

  async getAdditionalDetailsForVirtualAccnt(sellerCode) {
    // const uiConfig = await this.commonDataService.getUISellerConfig().toPromise();
    // if (uiConfig[sellerCode] && uiConfig[sellerCode].labelForIFSC) {
    //   this.ifscLabel = uiConfig[sellerCode].labelForIFSC;
    //   this.showBankNameForNEFTDialog = uiConfig[sellerCode].showBankNameForNEFTDialog;
    //   this.bankNameForNEFTDialog = uiConfig[sellerCode].bankNameForNEFTDialog;
    // }
  }
}
